import { ETopBetsErrorCode } from '../../../../redux/reducers/topBets';
import { IMappers } from '../../../../repositories/auction/v2/get-top-bets-by-announcement';
import { IGetTopBetsFail, IGetTopBetsSuccess } from '../types';
import { mapTopBets } from './mapTopBets';

export const mappers: IMappers<IGetTopBetsSuccess, IGetTopBetsFail> = {
  200: response => ({
    success: true,
    payload: mapTopBets(response),
  }),
  400: () => ({
    success: false,
    payload: ETopBetsErrorCode.badRequest,
  }),
};
